import {IUPAC, IupacPartialMapping} from 'biojs/BioConstants';

// Reverse + complement in a single pass. Instead of calling reverse(complement(seq)), we do
// them both at the same time to make this faster.
//
// NB client-side complement conservatively passes a base through unchanged if it is not in the
// lookup table.
export default function revcomp(seq: string, complementTable: IupacPartialMapping): string {
  let rc = '';
  let i = seq.length - 1;
  while (i >= 0) {
    const base = seq[i--];
    rc += complementTable[base as IUPAC] || base;
  }
  return rc;
}
